import { useState } from "react";
import { LogIn, LogOut } from "lucide-react";
import { useT } from "../i18n";
import { startGoogleLogin } from "./AuthCallback";

export const AccountBar = ({ user, onLogout, onDelete }) => {
  const t = useT();
  const [confirm, setConfirm] = useState(false);
  if (user === undefined) return <div className="account-bar" data-testid="account-loading" />;
  if (!user) {
    return (
      <div className="account-bar">
        <button type="button" className="btn-ghost btn-icon" onClick={startGoogleLogin} data-testid="google-login-button">
          <LogIn size={14} /> {t.login}
        </button>
        <span className="account-hint">{t.loginHint}</span>
      </div>
    );
  }
  return (
    <div className="account-bar" data-testid="account-signed-in">
      {user.picture && <img src={user.picture} alt="" className="avatar" referrerPolicy="no-referrer" />}
      <span className="account-name" data-testid="account-name">{user.name}</span>
      <button type="button" className="icon-btn" onClick={onLogout} aria-label={t.logout} title={t.logout} data-testid="logout-button">
        <LogOut size={14} />
      </button>
      {!confirm ? (
        <button type="button" className="link-btn" onClick={() => setConfirm(true)} data-testid="delete-account-button">{t.deleteAccount}</button>
      ) : (
        <span className="delete-confirm" data-testid="delete-account-confirm">
          {t.deleteConfirm}
          <button type="button" className="link-btn danger" onClick={onDelete} data-testid="delete-account-yes">{t.yes}</button>
          <button type="button" className="link-btn" onClick={() => setConfirm(false)} data-testid="delete-account-no">{t.no}</button>
        </span>
      )}
    </div>
  );
};
